import { useMemo } from 'react';
import { AddressInput as BaseAddressInput } from './DistanceFrom2Points';
import { AddressInfo, getAddressLabel } from './distanceUtils';
import { Parameter } from '@arra/core';

const replaceSemicolonsWithCommas = (str: string | undefined) => {
  if (!str) return '';
  return str.replace(/;/g, ',');
};

const AddressInput = ({
  label = "",
  parameter,
  onChange,
  disabled,
}: {
  label?: string;
  parameter: Parameter;
  onChange: (val: string) => void;
  disabled: boolean;
}) => {

  const handleOnSelect = (val: AddressInfo | null) => {
    if (!val) {
      onChange("");
      return;
    };
    const value = [
      replaceSemicolonsWithCommas(val?.street),
      replaceSemicolonsWithCommas(val?.postalCode),
      replaceSemicolonsWithCommas(val?.city),
      replaceSemicolonsWithCommas(val?.region),
      replaceSemicolonsWithCommas(val?.country)
    ].join(';');
    onChange(value);
  };

  const addressValue: AddressInfo | null = useMemo(() => {
    if (!parameter.value) {
      return null;
    }
    const [street, postalCode, city, region, country] = parameter.value.toString().split(';');
    const address: AddressInfo = { id: 0, label: '', street, postalCode, city, region, country, lat: 0, lon: 0 };
    return { ...address, label: getAddressLabel(address)};
  }, [parameter.value]);

  return <BaseAddressInput
    label={label}
    onSelect={handleOnSelect}
    value={addressValue}
    disabled={disabled}
  />
};

export default AddressInput;